module.exports = __webpack_public_path__ + "static/media/building_roof_flying.26a65f0a.svg";